import { ControlFacet, IControlOverrideOption } from '../models/controls/ControlFacet';
import { IEventContext } from '@ms/telemetry-manager/lib/IEvent';
import { IEventModifier } from '@ms/telemetry-manager/lib/EventBase';

export const telemetryContextControl: ControlFacet<{
  itemKey: string | undefined
}, {
    withContext: IEventModifier<IEventContext>;
  }> = new ControlFacet('telemetryContext', {
    withContext: telemetryContextOption()
  });

function telemetryContextOption(): IControlOverrideOption<IEventModifier<IEventContext>> {
  return {
    merge: (
      previous: IEventModifier<IEventContext> | undefined,
      current: IEventModifier<IEventContext> | undefined
    ): IEventModifier<IEventContext> | undefined => {
      return (context: IEventContext): IEventContext => {
        if (previous) {
          if (typeof previous === 'function') {
            context = {
              ...context,
              ...(previous(context) as IEventContext)
            };
          } else {
            context = {
              ...(previous as IEventContext),
              ...context
            };
          }
        }

        if (current) {
          if (typeof current === 'function') {
            context = {
              ...context,
              ...(current(context) as IEventContext)
            };
          } else {
            context = {
              ...(current as IEventContext),
              ...context
            };
          }
        }

        return context;
      };
    }
  };
}
